// src/context/AuthPromptContext.js
import React, { createContext, useState, useContext, useCallback, useRef } from "react";

const AuthPromptContext = createContext();

export const AuthPromptProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [promptConfig, setPromptConfig] = useState({
    title: "",
    body: "",
    source: "",
    submitLabel: "",
  });

  // Store success callback in a ref to avoid stale closures and rerender loops
  const onSuccessRef = useRef(null);

  const openAuthPrompt = useCallback(({ title, body, source, submitLabel, onSuccess } = {}) => {
    onSuccessRef.current = onSuccess || null;
    setPromptConfig({
      title: title || "Log in to continue",
      body: body || "",
      source: source || "",
      submitLabel: submitLabel || "Log In",
    });
    setIsOpen(true);
  }, []);

  const closeAuthPrompt = useCallback(() => {
    setIsOpen(false);
    // Clear callback on dismiss — the user chose not to log in
    onSuccessRef.current = null;
  }, []);

  const completeAuthPrompt = useCallback(() => {
    const callback = onSuccessRef.current;
    onSuccessRef.current = null;
    setIsOpen(false);
    if (typeof callback === "function") {
      callback();
    }
  }, []);

  return (
    <AuthPromptContext.Provider
      value={{ isOpen, promptConfig, openAuthPrompt, closeAuthPrompt, completeAuthPrompt }}
    >
      {children}
    </AuthPromptContext.Provider>
  );
};

export const useAuthPrompt = () => useContext(AuthPromptContext);
